import { render, staticRenderFns } from "./ClaimLimitSetupEdit.vue?vue&type=template&id=d027ac60"
import script from "./ClaimLimitSetupEdit.vue?vue&type=script&lang=js"
export * from "./ClaimLimitSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports